$(function() {
    'use strict';
    Odigeo.defineWidget('app_root', Odigeo.RootComponent);
});
